import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Avatar, Card, IconButton, Row, Stack, Text } from 'library/ui';
import { Create, Error } from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

import type { IWorkerTab } from '../types';

export function WorkerTab({
    worker,
    small,
    onClick,
    action,
    icon,
    attention,
}: {
    worker: IWorkerTab;
    small: boolean;
    onClick: () => void;
    action?: React.ReactNode;
    icon?: SvgIconComponent;
    attention?: boolean;
}) {
    return (
        <WorkerCard $small={small} padding="sm">
            <Row justify="between" align="center">
                <Row gap="sm" align="center">
                    <Avatar
                        imageUrl={worker.profile_image?.image}
                        initials={`${worker.user.first_name[0]}${worker.user.last_name[0]}`}
                    />
                    <Stack gap="none">
                        <Text>
                            {worker.user.first_name} {worker.user.last_name}{' '}
                            {attention && <Error sx={{ color: Colors.error, fontSize: 18 }} />}
                        </Text>
                        {!!worker.middle && (
                            <Text size="xs" component="div">
                                {worker.middle}
                            </Text>
                        )}
                        {!!worker.bottom && (
                            <Text size="xs" component="div">
                                {worker.bottom}
                            </Text>
                        )}
                    </Stack>
                </Row>
                {action ?? <IconButton icon={icon || Create} onClick={onClick} />}
            </Row>
        </WorkerCard>
    );
}

const WorkerCard = styled(Card, { shouldForwardProp: (prop) => prop !== '$small' })<{ $small: boolean }>(
    ({ $small }) => ({
        borderColor: Colors.secondary,
        width: $small ? '100%' : '60%',
    }),
);
